<script lang="ts">
  import { Toaster } from 'svelte-sonner';
  import { usePage } from '@inertiajs/svelte';
  import { SidebarProvider, SidebarTrigger } from '$lib/components/ui/sidebar/index.js';
  import AppSidebar from '$lib/components/AppSidebar.svelte';
  import * as DropdownMenu from "$lib/components/ui/dropdown-menu";
  import { Avatar, AvatarFallback, AvatarImage } from "$lib/components/ui/avatar";
  import { router } from '@inertiajs/svelte';
  import { LogOut, User, Settings } from "lucide-svelte";

  let { title, children } = $props();
  let open = $state(true);

  // 获取 Inertia 共享的 auth 数据
  const page = usePage();
  // 假设你的 User 对象中有 name 和 email_address
  const user = $derived($page.props.auth?.user);

  function handleLogout() {
    router.delete('/logout');
  }
</script>

<SidebarProvider bind:open>
  <div class="flex h-screen w-full overflow-hidden bg-background">
    <AppSidebar />

    <div class="flex-1 flex flex-col overflow-hidden">
      <header class="h-14 border-b flex items-center px-6 gap-4 bg-card shrink-0">
        <SidebarTrigger />
        <h1 class="text-xl font-semibold">{title}</h1>
        
        <div class="flex-1"></div>

        {#if user}
          <DropdownMenu.Root>
            <DropdownMenu.Trigger class="focus-visible:outline-none">
              <div class="flex items-center gap-3 hover:bg-accent p-1.5 rounded-full transition-colors cursor-pointer">
                <div class="text-right hidden sm:block">
                  <p class="text-xs font-medium leading-none">{user.name || '主理人'}</p>
                  <p class="text-[10px] text-muted-foreground leading-tight mt-1">{user.email_address}</p>
                </div>
                <Avatar class="h-8 w-8 border shadow-sm">
                  <AvatarImage src="" alt={user.name} />
                  <AvatarFallback class="bg-primary/10 text-primary text-xs uppercase">
                    {(user.name || user.email_address).substring(0, 2)}
                  </AvatarFallback>
                </Avatar>
              </div>
            </DropdownMenu.Trigger>
            
            <DropdownMenu.Content align="end" class="w-56 mt-2">
              <DropdownMenu.Label class="font-normal">
                <div class="flex flex-col space-y-1">
                  <p class="text-sm font-medium leading-none">{user.name}</p>
                  <p class="text-xs leading-none text-muted-foreground">{user.email_address}</p>
                </div>
              </DropdownMenu.Label>
              <DropdownMenu.Separator />
              <DropdownMenu.Group>
                <DropdownMenu.Item on:click={() => router.get('/users/show')}>
                  <User class="mr-2 h-4 w-4" />
                  个人空间
                </DropdownMenu.Item>
                <DropdownMenu.Item>
                  <Settings class="mr-2 h-4 w-4" />
                  偏好设置
                </DropdownMenu.Item>
              </DropdownMenu.Group>
              <DropdownMenu.Separator />
              <DropdownMenu.Item on:click={handleLogout} class="text-destructive focus:bg-destructive/10 focus:text-destructive">
                <LogOut class="mr-2 h-4 w-4" />
                安全退出
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Root>
        {:else}
          <a href="/login" class="text-sm font-medium hover:underline">登录</a>
        {/if}
      </header>

      <main class="flex-1 overflow-auto p-6 bg-zinc-50/30">
        {@render children?.()}
      </main>
    </div>
  </div>
</SidebarProvider>
<Toaster position="top-center" richColors />